import styled from "styled-components";

import { colorsPalettes, rgba } from "@similarweb/styles";
import { Flex } from "@similarweb/ui-components/foundations";

export const StyledChip = styled.button<{ $isSelected: boolean }>`
    display: flex;
    align-items: center;
    gap: 4px;
    padding: 4px 12px;
    border-radius: 16px;
    border: none;
    background: ${({ $isSelected }) =>
        $isSelected ? colorsPalettes.blue[100] : rgba(colorsPalettes.carbon[200], 0.2)};
    color: ${({ $isSelected }) => ($isSelected ? colorsPalettes.blue[500] : colorsPalettes.carbon[500])};
    cursor: pointer;

    &:hover {
        background: ${({ $isSelected }) =>
            $isSelected ? colorsPalettes.blue[100] : rgba(colorsPalettes.carbon[500], 0.1)};
    }
`;

export const StyledChipsRow = styled(Flex)`
    flex-wrap: wrap;
    gap: 8px;
    padding: 16px;
`;
